export default __webpack_public_path__ + "static/media/Bao-Nguyen-Resume.5da9da01.pdf";